import 'temporal-polyfill/global'

import {
  Vehicle_TypeEnum,
  Vehicle_PropulsionEnum,
  RetrieveVehicle_TypeEnum,
  RetrieveVehicle_PropulsionEnum,
  Stops_LineTypeEnum,
} from 'src/api/gen'
import { VehicleStateEnum } from 'src/api/provider-agency'
import { IDateTimeRange, IDateTimeRangeString } from 'src/components/DatePickers'

import { DockedStationEnum } from './LayersPopup'

export enum MAP_LAYERS {
  DeviceHighZoom = 'high_zoom',
  DeviceLowZoom = 'low_zoom',
}

export enum MapboxFilterEnum {
  'id',
  'category',
  'propulsion',
  'status',
  'provider',
  'lastTelemetryDate',
  'type',
}

export type FilterPanelValue =
  | string
  | string[]
  | VehicleStateEnum[]
  | Vehicle_TypeEnum[]
  | Vehicle_PropulsionEnum[]
  | IDateTimeRange
  | IDateTimeRangeString
  | Temporal.ZonedDateTime
  | undefined

export interface IMapSettings {
  satellite: '0' | '1'
  stopsLayers: Stops_LineTypeEnum[]
}

export interface IDockedStation {
  dockedStationLayers: DockedStationEnum[]
}

export interface IGBFSProvider {
  colors: { primary: string }
  hrid: string
  kind: 'standard'
  logo: string
  name: string
  url: string
}

export interface IStationInformation {
  address: string
  lat: number
  lon: number
  name: string
  region_id: string
  station_id: string
}

export interface IStationStatus {
  is_installed: number
  is_renting: number
  is_returning: number
  last_reported: number
  num_bikes_available: number
  num_bikes_available_types: {
    classic: number
    electric: number
    smart: number
  }
  num_docks_available: number
  station_id: string
}

interface IGBFSData {
  data: {
    station_information: IStationInformation[]
    station_status: IStationStatus[]
  }
  provider: IGBFSProvider
}

export interface IGBFSDataResponse {
  [providerId: string]: IGBFSData
}

export interface IFeature {
  geometry: {
    coordinates: [number, number]
    type: 'Point'
  }
  properties: {
    address: string
    lastReported: number
    numBikesAvailable: number
    numDocksAvailable: number
    provider: string
  }
  type: 'Feature'
}

export interface ISelectedStation {
  coordinates: mapboxgl.LngLat
  provider: IGBFSProvider
  station: IFeature
}

export interface IDeviceSupervisionMap {
  id: string
  identification_number: string
  last_known_battery_pct: number
  last_known_status: string
  last_known_timestamp: string
  position: [number, number]
  propulsion: RetrieveVehicle_PropulsionEnum[]
  provider: string
  provider_name: string
  type: RetrieveVehicle_TypeEnum
}
